function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

export default function derangeObjectArrayById(oA) {
  var dA = [].concat(_toConsumableArray(oA));
  if (dA.sort(function () {
    return Math.random() - 0.5;
  }).some(function (e, i) {
    return oA[i].id === e.id;
  })) {
    return derangeObjectArrayById(oA);
  }
  return dA;
}